import { AgentApiCitizenship } from './types';

// Временный список гражданств, пока на бэке нет ручки: выгрузка Place.citizenships
// в её порядке (сначала приоритетные страны). Используется в getAgentCitizenships.
export const CITIZENSHIPS_MOCK: AgentApiCitizenship[] = [
  { id: 225, name_ru: 'Россия', iso2: 'RU' },
  { id: 187, name_ru: 'Украина', iso2: 'UA' },
  { id: 149, name_ru: 'Беларусь', iso2: 'BY' },
  { id: 159, name_ru: 'Казахстан', iso2: 'KZ' },
  { id: 168, name_ru: 'Армения', iso2: 'AM' },
  { id: 169, name_ru: 'Грузия', iso2: 'GE' },
  { id: 167, name_ru: 'Азербайджан', iso2: 'AZ' },
  { id: 171, name_ru: 'Узбекистан', iso2: 'UZ' },
  { id: 209, name_ru: 'Таджикистан', iso2: 'TJ' },
  { id: 181, name_ru: 'Израиль', iso2: 'IL' },
  { id: 207, name_ru: 'Киргизия', iso2: 'KG' },
  { id: 117, name_ru: 'Литва', iso2: 'LT' },
  { id: 84, name_ru: 'США', iso2: 'US' },
  { id: 96, name_ru: 'Германия', iso2: 'DE' },
  { id: 29386, name_ru: 'Абхазия', iso2: 'AB' },
  { id: 211, name_ru: 'Австралия', iso2: 'AU' },
  { id: 113, name_ru: 'Австрия', iso2: 'AT' },
  { id: 10054, name_ru: 'Албания', iso2: 'AL' },
  { id: 20826, name_ru: 'Алжир', iso2: 'DZ' },
  { id: 11471, name_ru: 'Алушта', iso2: '' },
  { id: 21553, name_ru: 'Американские Виргинские острова', iso2: 'VI' },
  { id: 21182, name_ru: 'Ангола', iso2: 'AO' },
  { id: 10088, name_ru: 'Андорра', iso2: 'AD' },
  { id: 20856, name_ru: 'Антигуа и Барбуда', iso2: 'AG' },
  { id: 93, name_ru: 'Аргентина', iso2: 'AR' },
  { id: 21536, name_ru: 'Аруба', iso2: 'AW' },
  { id: 10090, name_ru: 'Афганистан', iso2: 'AF' },
  { id: 21325, name_ru: 'Багамские острова', iso2: 'BS' },
  { id: 10091, name_ru: 'Бангладеш', iso2: 'BD' },
  { id: 21019, name_ru: 'Барбадос', iso2: 'BB' },
  { id: 10532, name_ru: 'Бахрейн', iso2: 'BH' },
  { id: 21544, name_ru: 'Белиз', iso2: 'BZ' },
  { id: 114, name_ru: 'Бельгия', iso2: 'BE' },
  { id: 20869, name_ru: 'Бенин', iso2: 'BJ' },
  { id: 21546, name_ru: 'Бермудские Острова', iso2: 'BM' },
  { id: 115, name_ru: 'Болгария', iso2: 'BG' },
  { id: 10015, name_ru: 'Боливия', iso2: 'BO' },
  { id: 10057, name_ru: 'Босния и Герцеговина', iso2: 'BA' },
  { id: 21239, name_ru: 'Ботсвана', iso2: 'BW' },
  { id: 94, name_ru: 'Бразилия', iso2: 'BR' },
  { id: 21559, name_ru: 'Британские Виргинские острова', iso2: 'VG' },
  { id: 20274, name_ru: 'Бруней', iso2: 'BN' },
  { id: 21165, name_ru: 'Буркина-Фасо', iso2: 'BF' },
  { id: 21214, name_ru: 'Бурунди', iso2: 'BI' },
  { id: 21550, name_ru: 'Бутан', iso2: 'BT' },
  { id: 21556, name_ru: 'Вануату', iso2: 'VU' },
  { id: 21359, name_ru: 'Ватикан', iso2: 'VA' },
  { id: 102, name_ru: 'Великобритания', iso2: 'GB' },
  { id: 116, name_ru: 'Венгрия', iso2: 'HU' },
  { id: 21184, name_ru: 'Венесуэла', iso2: 'VE' },
  { id: 21562, name_ru: 'Восточный Тимор', iso2: 'TL' },
  { id: 10093, name_ru: 'Вьетнам', iso2: 'VN' },
  { id: 21137, name_ru: 'Габон', iso2: 'GA' },
  { id: 21321, name_ru: 'Гаити', iso2: 'HT' },
  { id: 21477, name_ru: 'Гайана', iso2: 'GY' },
  { id: 21010, name_ru: 'Гамбия', iso2: 'GM' },
  { id: 20802, name_ru: 'Гана', iso2: 'GH' },
  { id: 20968, name_ru: 'Гватемала', iso2: 'GT' },
  { id: 20818, name_ru: 'Гвинея', iso2: 'GN' },
  { id: 21143, name_ru: 'Гвинея-Бисау', iso2: 'GW' },
  { id: 10089, name_ru: 'Гибралтар', iso2: 'GI' },
  { id: 21175, name_ru: 'Гондурас', iso2: 'HN' },
  { id: 21426, name_ru: 'Гренада', iso2: 'GD' },
  { id: 21567, name_ru: 'Гренландия', iso2: 'GL' },
  { id: 246, name_ru: 'Греция', iso2: 'GR' },
  { id: 20747, name_ru: 'Гуам', iso2: 'GU' },
  { id: 203, name_ru: 'Дания', iso2: 'DK' },
  { id: 20762, name_ru: 'Демократическая Республика Конго', iso2: 'CD' },
  { id: 21475, name_ru: 'Джибути', iso2: 'DJ' },
  { id: 20746, name_ru: 'Доминика', iso2: 'DM' },
  { id: 20917, name_ru: 'Доминикана', iso2: 'DO' },
  { id: 1056, name_ru: 'Египет', iso2: 'EG' },
  { id: 21196, name_ru: 'Замбия', iso2: 'ZM' },
  { id: 20954, name_ru: 'Зимбабве', iso2: 'ZW' },
  { id: 994, name_ru: 'Индия', iso2: 'IN' },
  { id: 10095, name_ru: 'Индонезия', iso2: 'ID' },
  { id: 10535, name_ru: 'Иордания', iso2: 'JO' },
  { id: 20572, name_ru: 'Ирак', iso2: 'IQ' },
  { id: 10536, name_ru: 'Иран', iso2: 'IR' },
  { id: 10063, name_ru: 'Ирландия', iso2: 'IE' },
  { id: 10064, name_ru: 'Исландия', iso2: 'IS' },
  { id: 204, name_ru: 'Испания', iso2: 'ES' },
  { id: 205, name_ru: 'Италия', iso2: 'IT' },
  { id: 21551, name_ru: 'Йемен', iso2: 'YE' },
  { id: 21326, name_ru: 'Кабо-Верде', iso2: 'CV' },
  { id: 21570, name_ru: 'Каймановы острова', iso2: 'KY' },
  { id: 20975, name_ru: 'Камбоджа', iso2: 'KH' },
  { id: 20736, name_ru: 'Камерун', iso2: 'CM' },
  { id: 95, name_ru: 'Канада', iso2: 'CA' },
  { id: 21486, name_ru: 'Катар', iso2: 'QA' },
  { id: 21223, name_ru: 'Кения', iso2: 'KE' },
  { id: 20574, name_ru: 'Кипр', iso2: 'CY' },
  { id: 21572, name_ru: 'Кирибати', iso2: 'KI' },
  { id: 134, name_ru: 'Китай', iso2: 'CN' },
  { id: 10029, name_ru: 'Кокосовые острова', iso2: 'CC' },
  { id: 21191, name_ru: 'Колумбия', iso2: 'CO' },
  { id: 21297, name_ru: 'Коморские острова', iso2: 'KM' },
  { id: 21131, name_ru: 'Коста-Рика', iso2: 'CR' },
  { id: 20733, name_ru: 'Кот-д’Ивуар', iso2: 'CI' },
  { id: 10017, name_ru: 'Куба', iso2: 'CU' },
  { id: 10537, name_ru: 'Кувейт', iso2: 'KW' },
  { id: 21538, name_ru: 'Кюрасао', iso2: 'CW' },
  { id: 20972, name_ru: 'Лаос', iso2: 'LA' },
  { id: 206, name_ru: 'Латвия', iso2: 'LV' },
  { id: 21261, name_ru: 'Лесото', iso2: 'LS' },
  { id: 21278, name_ru: 'Либерия', iso2: 'LR' },
  { id: 10538, name_ru: 'Ливан', iso2: 'LB' },
  { id: 10023, name_ru: 'Ливия', iso2: 'LY' },
  { id: 10067, name_ru: 'Лихтенштейн', iso2: 'LI' },
  { id: 21203, name_ru: 'Люксембург', iso2: 'LU' },
  { id: 21241, name_ru: 'Маврикий', iso2: 'MU' },
  { id: 21349, name_ru: 'Мавритания', iso2: 'MR' },
  { id: 20854, name_ru: 'Мадагаскар', iso2: 'MG' },
  { id: 10068, name_ru: 'Македония', iso2: 'MK' },
  { id: 21151, name_ru: 'Малави', iso2: 'MW' },
  { id: 10097, name_ru: 'Малайзия', iso2: 'MY' },
  { id: 21004, name_ru: 'Мали', iso2: 'ML' },
  { id: 10098, name_ru: 'Мальдивы', iso2: 'MV' },
  { id: 10069, name_ru: 'Мальта', iso2: 'MT' },
  { id: 10020, name_ru: 'Марокко', iso2: 'MA' },
  { id: 101521, name_ru: 'Мартиника', iso2: 'MQ' },
  { id: 21578, name_ru: 'Маршалловы острова', iso2: 'MH' },
  { id: 20271, name_ru: 'Мексика', iso2: 'MX' },
  { id: 21235, name_ru: 'Мозамбик', iso2: 'MZ' },
  { id: 208, name_ru: 'Молдова', iso2: 'MD' },
  { id: 10070, name_ru: 'Монако', iso2: 'MC' },
  { id: 10099, name_ru: 'Монголия', iso2: 'MN' },
  { id: 37176, name_ru: 'Монтсеррат', iso2: 'MS' },
  { id: 10100, name_ru: 'Мьянма', iso2: 'MM' },
  { id: 21217, name_ru: 'Намибия', iso2: 'NA' },
  { id: 21582, name_ru: 'Науру', iso2: 'NR' },
  { id: 10101, name_ru: 'Непал', iso2: 'NP' },
  { id: 21339, name_ru: 'Нигер', iso2: 'NE' },
  { id: 20741, name_ru: 'Нигерия', iso2: 'NG' },
  { id: 118, name_ru: 'Нидерланды', iso2: 'NL' },
  { id: 21231, name_ru: 'Никарагуа', iso2: 'NI' },
  { id: 98542, name_ru: 'Ниуэ', iso2: 'NU' },
  { id: 139, name_ru: 'Новая Зеландия', iso2: 'NZ' },
  { id: 21584, name_ru: 'Новая Каледония', iso2: 'NC' },
  { id: 119, name_ru: 'Норвегия', iso2: 'NO' },
  { id: 98539, name_ru: 'Норфолк', iso2: 'NF' },
  { id: 108944, name_ru: 'Нью-Дели', iso2: '' },
  { id: 210, name_ru: 'ОАЭ', iso2: 'AE' },
  { id: 21586, name_ru: 'Оман', iso2: 'OM' },
  { id: 21574, name_ru: 'Острова Кука', iso2: 'CK' },
  { id: 10102, name_ru: 'Пакистан', iso2: 'PK' },
  { id: 21589, name_ru: 'Палау', iso2: 'PW' },
  { id: 98552, name_ru: 'Палестина', iso2: 'PS' },
  { id: 21299, name_ru: 'Панама', iso2: 'PA' },
  { id: 20739, name_ru: 'Папуа-Новая Гвинея', iso2: 'PG' },
  { id: 20992, name_ru: 'Парагвай', iso2: 'PY' },
  { id: 21156, name_ru: 'Перу', iso2: 'PE' },
  { id: 120, name_ru: 'Польша', iso2: 'PL' },
  { id: 10074, name_ru: 'Португалия', iso2: 'PT' },
  { id: 20764, name_ru: 'Пуэрто-Рико', iso2: 'PR' },
  { id: 21198, name_ru: 'Республика Конго', iso2: 'CG' },
  { id: 21371, name_ru: 'Руанда', iso2: 'RW' },
  { id: 10077, name_ru: 'Румыния', iso2: 'RO' },
  { id: 20769, name_ru: 'Сальвадор', iso2: 'SV' },
  { id: 20860, name_ru: 'Самоа', iso2: 'WS' },
  { id: 20790, name_ru: 'Сан-Марино', iso2: 'SM' },
  { id: 21199, name_ru: 'Сан-Томе и Принсипи', iso2: 'ST' },
  { id: 10540, name_ru: 'Саудовская Аравия', iso2: 'SA' },
  { id: 20789, name_ru: 'Сахарская Арабская Демократическая Республика', iso2: 'XA' },
  { id: 21251, name_ru: 'Свазиленд', iso2: 'SZ' },
  { id: 10104, name_ru: 'Северная Корея', iso2: 'KP' },
  { id: 10022, name_ru: 'Сейшелы', iso2: 'SC' },
  { id: 21441, name_ru: 'Сенегал', iso2: 'SN' },
  { id: 20754, name_ru: 'Сент-Винсент и Гренадины', iso2: 'VC' },
  { id: 21042, name_ru: 'Сент-Китс и Невис', iso2: 'KN' },
  { id: 21395, name_ru: 'Сент-Люсия', iso2: 'LC' },
  { id: 180, name_ru: 'Сербия', iso2: 'RS' },
  { id: 10105, name_ru: 'Сингапур', iso2: 'SG' },
  { id: 109724, name_ru: 'Синт-Мартен', iso2: 'SX' },
  { id: 10542, name_ru: 'Сирия', iso2: 'SY' },
  { id: 121, name_ru: 'Словакия', iso2: 'CS' },
  { id: 122, name_ru: 'Словения', iso2: 'SI' },
  { id: 20915, name_ru: 'Соломоновы острова', iso2: 'SB' },
  { id: 21227, name_ru: 'Сомали', iso2: 'SO' },
  { id: 20957, name_ru: 'Судан', iso2: 'SD' },
  { id: 21344, name_ru: 'Суринам', iso2: 'SR' },
  { id: 21219, name_ru: 'Сьерра-Леоне', iso2: 'SL' },
  { id: 995, name_ru: 'Таиланд', iso2: 'TH' },
  { id: 29385, name_ru: 'Тайвань', iso2: 'TW' },
  { id: 21208, name_ru: 'Танзания', iso2: 'TZ' },
  { id: 21595, name_ru: 'Тёркс и Кайкос', iso2: 'TC' },
  { id: 21171, name_ru: 'Того', iso2: 'TG' },
  { id: 21599, name_ru: 'Тонга', iso2: 'TO' },
  { id: 21187, name_ru: 'Тринидад и Тобаго', iso2: 'TT' },
  { id: 21601, name_ru: 'Тувалу', iso2: 'TV' },
  { id: 10024, name_ru: 'Тунис', iso2: 'TN' },
  { id: 170, name_ru: 'Туркмения', iso2: 'TM' },
  { id: 983, name_ru: 'Турция', iso2: 'TR' },
  { id: 21230, name_ru: 'Уганда', iso2: 'UG' },
  { id: 21289, name_ru: 'Уругвай', iso2: 'UY' },
  { id: 21580, name_ru: 'Федеративные Штаты Микронезии', iso2: 'FM' },
  { id: 10030, name_ru: 'Фиджи', iso2: 'FJ' },
  { id: 10108, name_ru: 'Филиппины', iso2: 'PH' },
  { id: 123, name_ru: 'Финляндия', iso2: 'FI' },
  { id: 101519, name_ru: 'Фолклендские острова', iso2: 'FK' },
  { id: 124, name_ru: 'Франция', iso2: 'FR' },
  { id: 21451, name_ru: 'Французская Гвиана', iso2: 'GF' },
  { id: 21330, name_ru: 'Французская Полинезия', iso2: 'PF' },
  { id: 10083, name_ru: 'Хорватия', iso2: 'HR' },
  { id: 21007, name_ru: 'Центрально-Африканская Республика', iso2: 'CF' },
  { id: 21331, name_ru: 'Чад', iso2: 'TD' },
  { id: 21610, name_ru: 'Черногория', iso2: 'ME' },
  { id: 125, name_ru: 'Чехия', iso2: 'CZ' },
  { id: 20862, name_ru: 'Чили', iso2: 'CL' },
  { id: 126, name_ru: 'Швейцария', iso2: 'CH' },
  { id: 127, name_ru: 'Швеция', iso2: 'SE' },
  { id: 10109, name_ru: 'Шри-Ланка', iso2: 'LK' },
  { id: 20785, name_ru: 'Эквадор', iso2: 'EC' },
  { id: 21045, name_ru: 'Экваториальная Гвинея', iso2: 'GQ' },
  { id: 20989, name_ru: 'Эритрея', iso2: 'ER' },
  { id: 179, name_ru: 'Эстония', iso2: 'EE' },
  { id: 20768, name_ru: 'Эфиопия', iso2: 'ET' },
  { id: 10021, name_ru: 'ЮАР', iso2: 'ZA' },
  { id: 135, name_ru: 'Южная Корея', iso2: 'KR' },
  { id: 29387, name_ru: 'Южная Осетия', iso2: 'XB' },
  { id: 108137, name_ru: 'Южный Судан', iso2: 'SS' },
  { id: 10013, name_ru: 'Ямайка', iso2: 'JM' },
  { id: 137, name_ru: 'Япония', iso2: 'JP' },
];
